$(document).on('turbolinks:load', function () {
  $('html').removeClass('scroll-lock');
});
